export default __webpack_public_path__ + "static/media/notification.714c31dd.svg";